'use es6';

import { USD } from 'self-service-api/constants/CurrencyCodes';
import { ACTIVE_CURRENCY_CODE_UPDATED } from 'pricing-pages-unified-ui/constants/ActionTypes';
const initialState = USD;

const ActiveCurrencyCode = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case ACTIVE_CURRENCY_CODE_UPDATED:
      return payload.currency;

    default:
      return state;
  }
};

export default ActiveCurrencyCode;